import React from "react";
import { Link } from "react-router-dom";

function ServiceCard({ title, description, image, link }) {
  return (
    <div className="service-card">
      <img src={image} alt={title} className="service-card-image" />
      <h3>{title}</h3>
      <p>{description}</p>
      <center>
      <Link to={link}>Learn More</Link></center>
    </div>
  );
}

export default ServiceCard;
